import List from './components/List'
import Form from './components/Form'

export default [
  {path: '/modality', component: List, name: 'modality.index'},
  {path: '/modality/store', component: Form, name: 'modality.store'},
  {path: '/modality/:id', component: Form, name: 'modality.update'}
]



// WEBPACK FOOTER //
// ./src/app/domains/modality/routes.js